<template>
  <AppView title="關於我們" :backable="true">
    <h2 class="text-center font-bold my-5 tracking-wider text-xl">營業時間</h2>
    <div class="mb-5 text-center">
      <div class="px-5">
        <div class="mb-3">
          <img :src="imgs.opening_hours" alt="營業時間" />
        </div>
      </div>
    </div>

    <hr class="m-5" />

    <div class="mb-5 text-center">
      <div class="px-5">
        <div class="mb-3">
          <img :src="imgs.about" alt="關於我們" />
        </div>
        <p class="text-sm mb-3 tracking-wider text-chicago">
          {{ info.address }}
        </p>
      </div>
    </div>

    <hr class="m-5" />

    <h2 class="text-center font-bold mb-5 tracking-wider text-xl">公司簡介</h2>
    <div class="px-5">
      <div class="tracking-wider">
        <img class="w-full mb-3" :src="imgs.shop" alt="店舖照片" />

        <h2 class="text-primary font-bold mb-2">{{ info.about?.title }}</h2>
        <div class="text-sm text-chicago mb-3" v-html="info.about?.content" />
      </div>
    </div>
  </AppView>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  auth: false,

  computed: {
    ...mapGetters({
      imgs: "app/imgs",
      info: "app/info",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
